import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Feedstock } from '../../../../models/project/feedstock/feedstock.model';
import { takeUntil } from 'rxjs/operators';
import { AnessaTranslationService } from '../../../../helper/translation/anessa-translation.service';
import { AbstractControl, NgForm } from '@angular/forms';
import { UserpilotReloader } from '../../../../helper/userpilot-reloader.component';

@Component({
  selector: 'app-feedstock-basic-info',
  templateUrl: './feedstock-basic-info.component.html',
  styleUrls: ['./feedstock-basic-info.component.scss']
})
export class FeedstockBasicInfoComponent extends UserpilotReloader implements OnInit, OnDestroy {
  @Input() anessaDatabaseRequired = false;
  @Input() projectInputDisplay = false;
  @Input() feedstock: Feedstock = null;
  @Input() feedstockUpdatedNotifier = new EventEmitter<Feedstock>();
  @Output() changesMadeNotifier = new EventEmitter();
  @Output() formIsValid = new EventEmitter<boolean>();
  @ViewChild('form') form: NgForm;

  quantitiesValid = true;
  characteristicsValid = true;

  showClearName = false;
  showClearDesc = false;

  onDestroyNotifier = new EventEmitter();
  /** trigger for translation pipe */
  trigger: string;

  constructor(public translationService: AnessaTranslationService) {
    super();
  }

  ngOnInit(): void {
    this.feedstockUpdatedNotifier.pipe(takeUntil(this.onDestroyNotifier))
    .subscribe(feedstock => {
      if (feedstock) {
        this.feedstock = feedstock;
      }
    });

    this.translationService.languageChangeNotifier
    .pipe(takeUntil(this.onDestroyNotifier))
    .subscribe(() => {
      this.trigger = this.translationService.getCurrentLang();
    });
  }

  ngOnDestroy(): void {
    this.onDestroyNotifier.emit();
    this.onDestroyNotifier.unsubscribe();
  }


  /**
   * clears the input that is using the provided property, assumes it is
   * part of the availability variable
   * @param property: the availability variable property name that is to be cleared
   */
  clearInput(property: string) {
    const newFeedstock = new Feedstock();
    this.feedstock[property] = newFeedstock[property];
    this.changesMadeNotifier.emit();
  }

  formValidityUpdated() {
    this.formIsValid.emit(this.quantitiesValid && this.characteristicsValid && this.form['form'].controls['name'].valid);
  }

  validateName() {
    if (this.feedstock.name.includes('.')) {
      const control: AbstractControl = this.form['form'].controls['name'];
      if (!control) { return; }
      control.setErrors({'incorrect-input': true});
      setTimeout(() => {
        control.markAsTouched();
      });
    }
  }

  getInfoText() {
    const info = [
      this.translationService.get('PROJECT.FEEDSTOCK.TYPE.INFO.1'),
      this.translationService.get('PROJECT.FEEDSTOCK.TYPE.INFO.2'),
      this.translationService.get('PROJECT.FEEDSTOCK.TYPE.INFO.3'),
      this.translationService.get('PROJECT.FEEDSTOCK.TYPE.INFO.4'),
      this.translationService.get('PROJECT.FEEDSTOCK.TYPE.INFO.5'),
      this.translationService.get('PROJECT.FEEDSTOCK.TYPE.INFO.6'),
      this.translationService.get('PROJECT.FEEDSTOCK.TYPE.INFO.7'),
      this.translationService.get('PROJECT.FEEDSTOCK.TYPE.INFO.8'),
      this.translationService.get('PROJECT.FEEDSTOCK.TYPE.INFO.9'),
      this.translationService.get('PROJECT.FEEDSTOCK.TYPE.INFO.10'),
      this.translationService.get('PROJECT.FEEDSTOCK.TYPE.INFO.11'),
    ];
    return this.translationService.get('PROJECT.FEEDSTOCK.TYPE.INFO.0') + '\n- ' + info.join('\n- ');
  }
}
